(ns frontend.view.nev.zap-vault.tab-permissions
  (:require [clojure.set :as set]
            [common.entity :as c-entity]
            [common.localization :as loc]
            [frontend.state.current-session :as session]
            [frontend.view.nev.zap-vault.event :as event]
            [frontend.view.nev.zap-vault.sub :as sub]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.layout.footer :as footer]
            [ui.components.layout.view :as layout]
            [ui.components.text.view :as text]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn view
  []
  (let [config @(rf/subscribe [::sub/config-with-updates])
        vault @(rf/subscribe [::sub/vault-with-updates])
        changes @(rf/subscribe [::sub/vault-and-config-changes])
        team-ids (:zap-vault/teams vault)
        member-ids (:zap-vault/members vault)
        owner-id (:common/owner vault)]
    [:div
     {:class "flex flex-col gap-2 border border-solid border-base-light-border-paler"}
     [:div
      {:class "flex flex-col gap-1 p-4 pb-0"}
      [text/h2
       (loc/tr :zap-vault-permissions)]
      [text/info-text
       (loc/tr :zap-vault-permissions-info)]]
     [:div
      {:class "flex flex-col gap-2 p-4 bg-base-regular items-start"}
      [:div
       {:class "flex flex-col gap-2 w-full max-w-[600px]"}
       [labelled-input/view
        {:editor-type              :editor.type/search
         :mandatory?               true
         :field/entity-types       [:entity.type/account]
         :field/not-clearable?     true
         :field/os-filter-terms-fn (fn [{:keys [] :as _args}]
                                     {"extras.active-user"             true
                                      "extras.account-modules.keyword" (subs (str :module/zap-vault) 1)})
         :value                    (when owner-id
                                     {:value owner-id
                                      :label (or (some-> owner-id
                                                         (session/get-entity)
                                                         (c-entity/display-string))
                                                 (loc/tr :disabled-account))})
         :label                    (loc/tr :zap-vault-owner)
         :on-change                (fn [selected-value _selected-option]
                                     (rf/dispatch [::event/vault-change :common/owner selected-value]))}]

       (when (true? (:vault-config/allow-members-configuration? config))
         [:<>
          [labelled-input/view
           {:editor-type              :editor.type/search
            :field/entity-types       [:entity.type/account]
            :field/os-filter-terms-fn (fn [{:keys [] :as _args}]
                                        {"extras.active-user"             true
                                         "extras.account-modules.keyword" (subs (str :module/zap-vault) 1)})
            :value                    nil
            :label                    (loc/tr :zap-vault/members)
            :on-change                (fn [selected-value _selected-option]
                                        (rf/dispatch [::event/vault-change :zap-vault/members (set/union (set member-ids)
                                                                                                         #{selected-value})]))}]
          (->> member-ids
               (map session/get-entity)
               (sort-by :account/last-name)
               (map (fn [member]
                      ^{:key (str "zap-vault-permission-" (:db/id member))}
                      [:div
                       {:class "group flex flex-row gap-2 min-h-5"}
                       [labelled-input/label-elem
                        {:label (c-entity/display-string member)}]
                       [layout/right-align
                        [:i
                         {:class    "fa fa-trash-alt hidden cursor-pointer group-hover:inline-block px-4"
                          :on-click (fn [_]
                                      (rf/dispatch [::event/vault-change :zap-vault/members (set/difference (set member-ids)
                                                                                                            #{(:db/id member)})]))}]]]))
               (doall))])

       (when (true? (:vault-config/allow-teams-configuration? config))
         [:<>
          [labelled-input/view
           {:editor-type              :editor.type/search
            :field/entity-types       [:entity.type/team]
            :field/os-filter-terms-fn (fn [{:keys [] :as _args}]
                                        {"original.team/modules.keyword" (subs (str :module/zap-vault) 1)})
            :value                    nil
            :label                    (loc/tr :zap-vault/teams)
            :on-change                (fn [selected-value _selected-option]
                                        (rf/dispatch [::event/vault-change :zap-vault/teams (set/union (set team-ids)
                                                                                                       #{selected-value})]))}]
          (->> team-ids
               (map session/get-entity)
               (sort-by :team/name)
               (map (fn [team]
                      ^{:key (str "zap-vault-permission-team-" (:db/id team))}
                      [:div
                       {:class "group flex flex-row gap-2 min-h-5"}
                       [labelled-input/label-elem
                        {:label (c-entity/display-string team)}]
                       [layout/right-align
                        [:i
                         {:class    "fa fa-trash-alt hidden cursor-pointer group-hover:inline-block px-4"
                          :on-click (fn [_]
                                      (rf/dispatch [::event/vault-change :zap-vault/teams (set/difference (set team-ids)
                                                                                                          #{(:db/id team)})]))}]]]))
               (doall))])

       [footer/footer
        [footer/left-align
         (when (seq changes)
           [button/secondary-hollow
            {:on-click #(rf/dispatch [::event/cancel-changes])}
            (loc/tr :cancel)])]
        [footer/right-align
         [button/primary-solid
          {:on-click  (fn [_]
                        (rf/dispatch [::event/save-changes changes]))
           :disabled? (empty? changes)}
          (loc/tr :save)]]]
       ]]]))
